export default __webpack_public_path__ + "static/media/successful-purchase.27dab721.jpg";